"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableIMap = void 0;
const mobx_1 = require("mobx");
class ObservableIMap {
    constructor() {
        this._values = mobx_1.observable.map({}, { deep: false });
    }
    get(key) {
        return this._values.get(key);
    }
    set(key, value) {
        this._values.set(key, value);
    }
    has(key) {
        return this._values.has(key);
    }
    keys() {
        return Array.from(this._values.keys());
    }
    values() {
        return Array.from(this._values.values());
    }
    clear() {
        this._values.clear();
    }
    delete(key) {
        this._values.delete(key);
    }
    get size() {
        return this._values.size;
    }
}
exports.ObservableIMap = ObservableIMap;
//# sourceMappingURL=observable.map.js.map